import { observer } from "mobx-react-lite";

import { useAuthenticatedNavigationContext } from "./AuthenticatedNavigationContext";
import { SaveIndicator } from "./SaveIndicator";

export const NavbarSavingIndicator = observer(function NavbarSavingIndicator() {
  const { saving } = useAuthenticatedNavigationContext();

  return <SaveIndicator status={saving.status} />;
});
